import React from 'react'

const PendingUserList = (props) => {
    const acceptedSession = () => {
        props.sessionAccepted(props.item.session_id);
    }
    const rejectedSession = () => {
        props.sessionRejected(props.item.session_id);
    }
    return (
        <div className='col-md-12'>
            <div className="alert alert-primary p-5 border border-dashed border-primary">
                <div className='row'>
                    <div className='col-md-8'>
                        <div className="d-flex flex-column">
                            <h4 className="mb-1 text-primary">Agent Assistance Needed</h4>
                            <span>
                                A conversation has been escalated for your attention. Please review the chat and address the customer's query promptly.
                            </span>
                        </div>
                    </div>
                    <div className='col-md-4 text-end m-auto'>
                        <button type="button" className="btn btn-success btn-sm me-2" onClick={acceptedSession}>
                            Accept
                        </button>
                        <button type="button" className="btn btn-danger btn-sm me-2" onClick={rejectedSession}>
                            Reject
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PendingUserList